/**
 * Google's "G", in Google's own four colours.
 *
 * The brand-mandated multicolour mark, kept verbatim — this is the one place
 * raw hex belongs in a component, because the colours ARE the identification.
 * The flat single-colour version it replaces read as a generic red glyph, which
 * is exactly what a provider mark must not do.
 *
 * Its own file because two surfaces need the same glyph — the sign-in buttons
 * and the linked-accounts list in `/pl/panel/bezpieczenstwo` — and a provider
 * mark that differs between "connect" and "connected" reads as two different
 * providers. Decorative: the label beside it carries the meaning.
 */
export function GoogleMark({ size = 16 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      className="shrink-0"
    >
      <path
        fill="#4285F4"
        d="M23.52 12.27c0-.86-.08-1.68-.22-2.47H12v4.68h6.46a5.52 5.52 0 0 1-2.4 3.62v3h3.88c2.27-2.09 3.58-5.17 3.58-8.83z"
      />
      <path
        fill="#34A853"
        d="M12 24c3.24 0 5.96-1.07 7.94-2.9l-3.88-3c-1.08.72-2.45 1.15-4.06 1.15-3.12 0-5.77-2.11-6.71-4.95H1.28v3.09A12 12 0 0 0 12 24z"
      />
      <path fill="#FBBC05" d="M5.29 14.3a7.2 7.2 0 0 1 0-4.6V6.62H1.28a12 12 0 0 0 0 10.77z" />
      <path
        fill="#EA4335"
        d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.44-3.44C17.95 1.19 15.24 0 12 0A12 12 0 0 0 1.28 6.62l4.01 3.09C6.23 6.86 8.88 4.75 12 4.75z"
      />
    </svg>
  )
}
